import { render, staticRenderFns } from "./Turntable.vue?vue&type=template&id=074c49d6&scoped=true&"
import script from "./Turntable.vue?vue&type=script&lang=js&"
export * from "./Turntable.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/turntable.css?vue&type=style&index=0&id=074c49d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074c49d6",
  null
  
)

export default component.exports